import React, { useState } from "react";
import MultiSelectCm from "../MultiSelectCm/MultiSelectCm";
import { useDispatch, useSelector } from "react-redux";
import Select, { components } from "react-select";
import { Actions } from "../../Action";
import { bindActionCreators } from "redux";
import VizButton from "../VizButtons/VizButton";
import { Tag } from "antd";
import ConfigModal from "./ConfigModal";
import { isObjectDefinedAndNotNull } from "./RestrictPermission";
const ValueContainer = ({ children, ...props }) => {
  let [values, input] = children;
  if (Array.isArray(values)) {
    const plural = values.length === 1 ? "" : "s";
    values = `${values.length} selected`;
  }

  return (
    <components.ValueContainer {...props}>
      {values}
      {input}
    </components.ValueContainer>
  );
};
const customStyles = {
  // menu: (provided) => ({
  //   ...provided,
  //   zIndex: 9999,
  // }),

  control: (base) => ({
    ...base,
    height: 29,
    minHeight: 29,
    marginBottom: 5,
    borderColor: "lightgray",
    // width: "120px",
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    paddingTop: 0,
    paddingBottom: 0,
    color: "lightgray",
  }),
  clearIndicator: (styles) => ({
    ...styles,
    paddingTop: 0,
    paddingBottom: 0,
    color: "lightgray",
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isFocused
      ? "var(--light_color_shade)"
      : state.isSelected
      ? "var(--light_color_shade)"
      : "none",
    color: state.isFocused || state.isSelected ? "#fff" : "none",
  }),
};
export const isEmptyObject = (obj) => {
  return Object.keys(obj).length === 0;
};

function RegionSelection({ actionLevelRestriction, setRegionName }) {
  const state = useSelector((state) => state?.restrictPermission);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { selectRegionAction, SelectedCountryValueAction } = bindActionCreators(
    Actions,
    dispatch
  );
  const onChangeSelectedOption = (value) => {
    selectRegionAction(value);
  };
  const onChangeSelectedCountryOption = (value) => {
    SelectedCountryValueAction(value);
  };
  let checkBoolean =
    actionLevelRestriction &&
    typeof actionLevelRestriction === "object" &&
    isEmptyObject(actionLevelRestriction)
      ? true
      : false;

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "baseline",
      }}
    >
      <div style={{ display: "flex" }}>
        <span>
          <Select
            className={"multiselect3"}
            onChange={onChangeSelectedOption}
            placeholder="Region"
            options={state?.RegionValues}
            value={state?.SelectedRegionValue}
            components={{ ValueContainer }}
            // closeMenuOnSelect={!isMulti}
            styles={customStyles}
            hideSelectedOptions={false}
            isClearable
          />
        </span>
        <span style={{ marginLeft: "10px" }}>
          <Select
            className={"multiselect3"}
            onChange={onChangeSelectedCountryOption}
            placeholder="Country"
            countryValues
            options={state?.countryValues}
            value={state?.selectedCountryValue}
            components={{ ValueContainer }}
            // closeMenuOnSelect={!isMulti}
            styles={customStyles}
            hideSelectedOptions={false}
            isClearable
          />
        </span>
      </div>
      <div>
        <span>
          {/* <Button>Button</Button> */}
          <VizButton
            type={checkBoolean ? "Disabled" : "Primary"}
            onClick={() => setOpen(true)}
          >
            View Existing Configuration
          </VizButton>
        </span>
        {open && isObjectDefinedAndNotNull(actionLevelRestriction) ? (
          <ConfigModal
            open={open}
            setOpen={setOpen}
            handleOpen={handleOpen}
            handleClose={handleClose}
            setRegionName={setRegionName}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default RegionSelection;
